/** biome-ignore-all lint/suspicious/noVar: <teste> */
'use client'

import { usePathname } from 'next/navigation'
import { useEffect } from 'react'
import { isPostgraduateChatRoute } from '@/lib/postgraduate-chat/route'

export function ChatwootConfig({ websiteToken }: { websiteToken: string }) {
  const pathname = usePathname()
  const isHiddenForPostgraduateChat = isPostgraduateChatRoute(pathname)

  useEffect(() => {
    // HN-3170: nas páginas de pós-graduação o widget padrão ("Fale
    // Conosco") some, substituído pelo chat comercial — ver
    // `PostgraduateChat`. A ocultação é via CSS (`data-hide-chatwoot` em
    // globals.css): `$chatwoot.toggleBubbleVisibility` lança `classList of
    // null` no tipo `expanded_bubble` e derrubava a navegação SPA.
    document.documentElement.toggleAttribute(
      'data-hide-chatwoot',
      isHiddenForPostgraduateChat
    )

    // SDK já carregado (navegação SPA vinda de outra página): não recarrega.
    if (window.chatwootSDK && window.$chatwoot) {
      return
    }

    if (isHiddenForPostgraduateChat) {
      return
    }

    window.chatwootSettings = {
      showUnreadMessagesDialog: true,
      position: 'right',
      locale: 'pt_BR',
      useBrowserLanguage: true,
      type: 'expanded_bubble',
      launcherTitle: 'Fale conosco',
    }

    ;((d, t) => {
      var BASE_URL = 'https://chatwoot.zamply.com.br'
      var g = d.createElement(t) as HTMLScriptElement,
        s = d.getElementsByTagName(t)[0]
      // biome-ignore lint/style/useTemplate: <test>
      g.src = BASE_URL + '/packs/js/sdk.js'
      g.defer = true
      g.async = true
      s.parentNode?.insertBefore(g, s)
      g.onload = () => {
        window.chatwootSDK.run({
          websiteToken,
          baseUrl: BASE_URL,
        })
      }
    })(document, 'script')
  }, [websiteToken, isHiddenForPostgraduateChat])

  return null
}
